import { OnboardingStepProps } from '../types';

import VsimavecHead from '../../../assets/vsimavec-head.svg';
import Tabs from '../../tabs/Tabs';
import { useState } from 'react';
import {
    UilBackpack,
    UilCalculator,
    UilPentagon,
} from '@iconscout/react-unicons';
import { Button } from '../../buttons/Button';
import { Video } from '../Video';

export function StepTargetAudience({ onNext, category }: OnboardingStepProps) {
    const [selectedTabIndex, setSelectedTabIndex] = useState(0);

    const tabs = [
        {
            id: 'materska-skola',
            label: 'Mateřská škola',
            icon: UilPentagon,
            content: <Video slug="materska-skola" category={category} />,
        },
        {
            id: '1-3-trida',
            label: '1. – 3. třída',
            icon: UilBackpack,
            content: <Video slug="1-3-trida" category={category} />,
        },
        {
            id: '4-5-trida',
            label: '4. – 5. třída',
            icon: UilCalculator,
            content: <Video slug="4-5-trida" category={category} />,
        },
    ];

    return (
        <>
            {/* Header */}
            <div className="text-center">
                <div className="mx-auto mb-6 w-20">
                    <img
                        src={VsimavecHead}
                        alt="Logo"
                        className="h-full w-full object-contain"
                    />
                </div>
                <h1 className="text-5xl">S jakou skupinou budete pracovat?</h1>
                <p className="mb-6 text-ink-800">
                    <strong>
                        Jaké přínosy má Všímavec pro&nbsp;konkrétní věkovou
                        skupinu?
                    </strong>{' '}
                    <br />
                    Podívejte&nbsp;se na&nbsp;praktické tipy: jak začít
                    a&nbsp;jak s&nbsp;aplikací pracovat z&nbsp;pohledu věku
                    dětí.
                </p>
            </div>

            {/* Group Selection */}
            <div className="w-full flex-1">
                <Tabs
                    heading={null}
                    state={[selectedTabIndex, setSelectedTabIndex]}
                    tabs={tabs.map((role) => ({
                        id: role.id,
                        label: (
                            <div className="flex items-center gap-2">
                                <role.icon size={16} />
                                {role.label}
                            </div>
                        ),
                        content: role.content,
                    }))}
                    variant="onboarding"
                />
            </div>

            {/* Button */}
            <div className="flex w-full max-w-[540px] flex-col gap-2">
                <Button
                    color="product"
                    className="text-base"
                    onClick={() => onNext('_complete')}
                >
                    Přejít na doporučená cvičení
                </Button>
            </div>
        </>
    );
}
